import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { Layout } from './Layouts'

export const PrivateRoutes = () => {
    return (
        <Routes>
            <Route element={<Layout layout={'OFFICE'} requireAuth={true} fullWidth={true} allowedRoles={['ADMIN', 'MANAGER']} />} >
                {/* Note: '/' route moved to PublicRoutes for homepage */}
            </Route>

            <Route element={<Layout layout={'OFFICE'} requireAuth={true} fullWidth={false} allowedRoles={['ADMIN', 'MANAGER']} />} >
            </Route>

            <Route element={<Layout layout={'OFFICE'} requireAuth={true} fullWidth={false} allowedRoles={['STAFF']} />} >
            </Route>
        </Routes>
    )
}
